import {formatDateToBDD} from "../../utils/tools";
// import {decimalToCentsNoRound} from "../../utils/monetary";
import {HttpMethod, initFetch} from "../../utils/fetcher";
import {SAVE_SUCCESS_REQUETES} from "./requeteAction";
import {SAVE_SUCCESS_REQUETES_LOTS} from "./requeteLotAction";
import {SAVE_SUCCESS_LOCATIONS} from "./locationAction";
import {SAVE_SUCCESS_MULTIPLE_ECRITURES} from "./ecritureAction";
import {requeteLotToAdapted} from "../../adapter/requeteLotAdapter";
import {locationToAdapted} from "../../adapter/locationAdapter";
import {requeteToAdapted} from "../../adapter/requeteAdapter";
import {ecrituresToAdapted} from "../../adapter/ecritureAdapter";
import {locataireToAdapted} from "../../adapter/locataireAdapter";
import {SAVE_SUCCESS_LOCATAIRES} from "./locataireAction";

export const FETCH_BOOKINGS_REQUEST = 'FETCH_BOOKINGS_REQUEST';
export const FETCH_BOOKINGS_SUCCESS = 'FETCH_BOOKINGS_SUCCESS';
export const FETCH_BOOKINGS_FAILURE = 'FETCH_BOOKINGS_FAILURE';

export const ADD_BOOKING_REQUEST = 'ADD_BOOKING_REQUEST';
export const ADD_BOOKING_SUCCESS = 'ADD_BOOKING_SUCCESS';
export const ADD_BOOKING_FAILURE = 'ADD_BOOKING_FAILURE';

export const UPDATE_BOOKING_REQUEST = 'UPDATE_BOOKING_REQUEST';
export const UPDATE_BOOKING_SUCCESS = 'UPDATE_BOOKING_SUCCESS';
export const UPDATE_BOOKING_FAILURE = 'UPDATE_BOOKING_FAILURE';

export const DELETE_BOOKING_REQUEST = 'DELETE_BOOKING_REQUEST';
export const DELETE_BOOKING_SUCCESS = 'DELETE_BOOKING_SUCCESS';
export const DELETE_BOOKING_FAILURE = 'DELETE_BOOKING_FAILURE';

export const ARRHES_BOOKING_REQUEST = 'ARRHES_BOOKING_REQUEST';
export const ARRHES_BOOKING_SUCCESS = 'ARRHES_BOOKING_SUCCESS';
export const ARRHES_BOOKING_FAILURE = 'ARRHES_BOOKING_FAILURE';

// Fonction utilitaire pour dispatcher les données supplémentaires
const dispatchAdditionalData = (dispatch, data) => {

	const {requete, requeteLots, location, accounting} = data;
	const adaptedValues = {};

	if (requete) {
		const adaptedRequete = requeteToAdapted(requete);
		dispatch({
			type: SAVE_SUCCESS_REQUETES,
			payload: adaptedRequete
		});
		adaptedValues.requete = adaptedRequete;

		if (requete.locataire) {
			const adaptedLocataire = locataireToAdapted(requete.locataire);
			dispatch({
				type: SAVE_SUCCESS_LOCATAIRES,
				payload: adaptedLocataire
			});
			adaptedValues.locataire = adaptedLocataire;
		}
	}

	if (requeteLots) {
		const adaptedRequeteLots = requeteLotToAdapted(requeteLots);
		dispatch({
			type: SAVE_SUCCESS_REQUETES_LOTS,
			payload: adaptedRequeteLots
		});
		adaptedValues.requeteLots = adaptedRequeteLots;
	}

	if (location) {
		const adaptedLocation = locationToAdapted(location);
		dispatch({
			type: SAVE_SUCCESS_LOCATIONS,
			payload: adaptedLocation
		});
		adaptedValues.location = adaptedLocation;
	}

	if (accounting) {
		const adaptedAccounting = ecrituresToAdapted(accounting);
		dispatch({
			type: SAVE_SUCCESS_MULTIPLE_ECRITURES,
			payload: adaptedAccounting
		});
		adaptedValues.accounting = adaptedAccounting;
	}

	// Retourner toutes les valeurs adaptées
	return adaptedValues;
};

export function fetchBookings() {
	return async (dispatch) => {
		dispatch({ type: FETCH_BOOKINGS_REQUEST });

		try {
			const { url, params } = initFetch(`bookings`, HttpMethod.GET);
			const response = await fetch(url, params)

			if (!response.ok) {
				throw new Error('Erreur lors de la récupération des données');
			}

			const data = await response.json();

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: FETCH_BOOKINGS_SUCCESS,
				payload: data.bookings // Extraire le tableau bookings
			});
		} catch (error) {
			dispatch({
				type: FETCH_BOOKINGS_FAILURE,
				payload: error.message
			});
		}
	}
}

export function addBooking(bookingData) {

	return async (dispatch) => {
		dispatch({ type: ADD_BOOKING_REQUEST });

		try {
			const formattedData = {
				...bookingData,
				start_at: formatDateToBDD(bookingData.start_at),
				end_at: formatDateToBDD(bookingData.end_at),
				deposit_at: formatDateToBDD(bookingData.deposit_at),
				//price: decimalToCentsNoRound(bookingData.price),
				//deposit_owner: decimalToCentsNoRound(bookingData.deposit_owner),
				//deposit_tenant: decimalToCentsNoRound(bookingData.deposit_tenant),
			}

			const { url, params } = initFetch(`bookings/store`, HttpMethod.POST);
			const response = await fetch(url, { ...params, body: JSON.stringify(formattedData) })

			if (!response.ok) {
				throw new Error('Erreur lors de l\'ajout');
			}

			const data = await response.json();
			//console.log('action',data);

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: ADD_BOOKING_SUCCESS,
				payload: data.booking // Extraire l'objet booking
			});

			dispatchAdditionalData(dispatch, data);

		} catch (error) {
			dispatch({
				type: ADD_BOOKING_FAILURE,
				payload: error.message
			});
		}
	};
}

// bookingData = lot_id
export function updateBooking(id, bookingData) {
	return async (dispatch) => {
		dispatch({ type: UPDATE_BOOKING_REQUEST });

		try {

			const formattedData = {
				...bookingData,
				//price: decimalToCentsNoRound(bookingData.price),
				start_at: formatDateToBDD(bookingData.start_at),
				end_at: formatDateToBDD(bookingData.end_at),
			}

			const { url, params } = initFetch(`bookings/${id}`, HttpMethod.PUT);
			const response = await fetch(url, { ...params, body: JSON.stringify(formattedData) })

			if (!response.ok) {
				throw new Error('Erreur lors de la mise à jour!');
			}

			const data = await response.json();

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: UPDATE_BOOKING_SUCCESS,
				payload: data.booking // Extraire l'objet booking
			});

			//return dispatchAdditionalData(dispatch, data);

		} catch (error) {
			dispatch({
				type: UPDATE_BOOKING_FAILURE,
				payload: error.message
			});
		}
	}
}

// Ajout du lot
export function productBooking(id, bookingData) {
	return async (dispatch) => {
		dispatch({ type: UPDATE_BOOKING_REQUEST });

		try {

			const { url, params } = initFetch(`bookings/${id}/product`, HttpMethod.PUT);
			const response = await fetch(url, { ...params, body: JSON.stringify(bookingData) })

			if (!response.ok) {
				throw new Error('Erreur lors de la mise à jour!');
			}

			const data = await response.json();

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: UPDATE_BOOKING_SUCCESS,
				payload: data.booking // Extraire l'objet booking
			});

			return dispatchAdditionalData(dispatch, data);

		} catch (error) {
			dispatch({
				type: UPDATE_BOOKING_FAILURE,
				payload: error.message
			});
		}
	}
}


export function deleteBooking(id) {
	return async (dispatch) => {
		dispatch({ type: DELETE_BOOKING_REQUEST });
		try {
			const { url, params } = initFetch(`bookings/destroy/${id}`, HttpMethod.DELETE);
			const response = await fetch(url, params);

			if (!response.ok) {
				throw new Error('Erreur lors de la suppression');
			}

			const data = await response.json();
			//console.log('action',data);

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: DELETE_BOOKING_SUCCESS,
				payload: data.booking?.id // Extraire l'objet booking
			});

			dispatchAdditionalData(dispatch, data);

		} catch (error) {
			dispatch({
				type: DELETE_BOOKING_FAILURE,
				payload: error.message
			});
		}
	}
}

// bookingData = amount
export function arrhesBooking(id, bookingData) {
	return async (dispatch) => {
		dispatch({ type: ARRHES_BOOKING_REQUEST });

		try {
			const formattedData = {
				...bookingData,
				deposit_at: formatDateToBDD(bookingData.deposit_at),
				//deposit_tenant: decimalToCentsNoRound(bookingData.deposit_tenant)
			}

			const { url, params } = initFetch(`bookings/${id}/arrhes`, HttpMethod.PUT);
			const response = await fetch(url, { ...params, body: JSON.stringify(formattedData) })

			if (!response.ok) {
				throw new Error('Erreur lors de la mise à jour!');
			}

			const data = await response.json();

			// Vérifier le statut de la réponse API
			if (!data.status) {
				throw new Error(data.message || 'Erreur API');
			}

			dispatch({
				type: ARRHES_BOOKING_SUCCESS,
				payload: data.booking // Extraire l'objet booking
			});

			dispatchAdditionalData(dispatch, data);

			return data.booking;

		} catch (error) {
			dispatch({
				type: ARRHES_BOOKING_FAILURE,
				payload: error.message
			});
		}
	}
}
